import React from 'react';
import { Route } from 'react-router';
import moment from 'moment';

import PaymentExport from './PaymentExport';

// eslint-disable-next-line no-unused-vars
const preparePaymentExportParams = (params, { location }) => {
  const startDate = moment()
    .set('date', 26)
    .subtract(1, 'month')
    .format('YYYY-MM-DD');
  const endDate = moment()
    .set('date', 25)
    .format('YYYY-MM-DD');

  return {
    ...params,
    startDate,
    endDate,
  };
};

const FinancialRoutes = (
  <Route
    path="/admin/finance/payment-export"
    component={PaymentExport}
    prepareParams={preparePaymentExportParams}
  />
);

export default FinancialRoutes;



// WEBPACK FOOTER //
// ./src/modules/financial/FinancialRoutes.js